const createPosName = ({ type = '', paCode = '', description = '' }) => {
  let posName = type || ''
  if (paCode) posName = `${posName}:${paCode}`
  if (description) posName = `${posName} - ${description}`
  return posName
}

export default createPosName
